import { render, staticRenderFns } from "./ModifierGroupPriority.vue?vue&type=template&id=686898d2&scoped=true"
import script from "./ModifierGroupPriority.vue?vue&type=script&lang=js"
export * from "./ModifierGroupPriority.vue?vue&type=script&lang=js"
import style0 from "./ModifierGroupPriority.vue?vue&type=style&index=0&id=686898d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686898d2",
  null
  
)

export default component.exports